(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/promos/views/match-promos.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/promos/views/match-promos.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.app.productStartPage.promos.views.MatchPromos = svs.app.productStartPage.promos.views.Promo.extend({
    className: 'grid-row',
    childView: svs.app.productStartPage.promos.views.MatchPromo,
    emptyView: svs.app.productStartPage.promos.views.NoOpenDraws,
    childViewContainer: '.js-match-promo-container',
    ui: {
      background: '.promo-box-background'
    },
    template: function(data) {
      return svs.app.product_start_page.templates.match_promos(data);
    },
    initialize: function() {
      if (this.model.get('showNoOpenDraws')) {
        this.collection.reset();
      }
    },
    childViewOptions: function(model, index) {
      return {
        itemIndex: index,
        noOpenDrawsText: this.model.get('noOpenDrawsText')
      };
    },
    onRender: function() {
      this.initBackgroundImage();
    }
  });
})(Backbone, _, svs);

 })(window);